// extracted by mini-css-extract-plugin
module.exports = {"button":"SecondButton-button-9539","image":"SecondButton-image-9539"};